// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1F7nr","tab":"Tabs_tab__38PfO","tabActive":"Tabs_tabActive__1lpIn"};